
// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');

// @helpers
const { formatText } = require('core/i18n').i18n;
const { sendTextToClipBoard } = require('commonsUtilities/clipBoardHelper');
const { getLastNChars } = require('utilities/stringHelper');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @components
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');
const AccountBringBankAccount = require('components/accountBringBankAccount/accountBringBankAccount');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
import extendAccountFunctionality from 'components/accounts/extendAccountFunctionality/extendAccountFunctionality';

class accountBringBankAccountView extends React.Component {
    constructor(props) {
        super(props);
    }

    buildTooltipContent(iban) {
        return (
            <React.Fragment>
                {iban}
                <button
                    className="icon__tooltip icon-copiar account-movements__tooltip-iban-icon"
                    onClick={() => sendTextToClipBoard(iban)}>
                </button>
            </React.Fragment>
        );
    }

    buildSubtitleRight(immAccount) {
        const iban = immAccount.get('iban');
        const toolTipContent = this.buildTooltipContent(iban);
        const target = <span className="ok-header-sub-page__subtitle-right">{getLastNChars(iban)}</span>;
        let blockedTag = null;

        return (
            <React.Fragment>
                <OKTooltip
                    content={toolTipContent}
                    offset={[60, 15]}
                    placement="bottom"
                    target={target}
                />
                {blockedTag}
            </React.Fragment>
        );
    }

    buildMappingBreadCrumb(immAccount, accountId) {
        return [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: immAccount.get('alias'),
                url: `/myprofile/accounts/${accountId}/movements`
            },
            {
                text: formatText('breadcrumb-breadcrumb_bringBankAccount'),
                url: ''
            }
        ];
    }

    render() {
        const { match: { params: { accountId } }, immAccounts, handleOptionsClick } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId]);
        const subtitleLeft = immAccount.get('catalogData').get('subtype');

        const subtitleRight = this.buildSubtitleRight(immAccount);
        const mappingBreadcrumb = this.buildMappingBreadCrumb(immAccount, accountId);

        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="medium"
                            section="accounts"
                            customClass="col-xs-12"
                        >
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                subtitleLeft={subtitleLeft}
                                subtitleRight={subtitleRight}
                                finalTitle={formatText('bringBankAccount-bringBankAccount_pageTitle')}
                            >
                                <AccountMoreOptionsButton accountId={accountId} onOptionClick={handleOptionsClick} />
                            </OKHeaderSubPage>
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <AccountBringBankAccount />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

accountBringBankAccountView.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

module.exports.accountBringBankAccountView = connect(
    state => ({
        immAccounts: state.accounts,
    }),
    null
)(extendAccountFunctionality(accountBringBankAccountView));
